__turbopack_context__.v({
  "chevron": "Breadcrumbs-module-scss-module__Xu-Rca__chevron",
  "current": "Breadcrumbs-module-scss-module__Xu-Rca__current",
  "currentCta": "Breadcrumbs-module-scss-module__Xu-Rca__currentCta",
  "dot": "Breadcrumbs-module-scss-module__Xu-Rca__dot",
  "expander": "Breadcrumbs-module-scss-module__Xu-Rca__expander",
  "item": "Breadcrumbs-module-scss-module__Xu-Rca__item",
  "itemCta": "Breadcrumbs-module-scss-module__Xu-Rca__itemCta",
  "link": "Breadcrumbs-module-scss-module__Xu-Rca__link",
  "linkCta": "Breadcrumbs-module-scss-module__Xu-Rca__linkCta",
  "list": "Breadcrumbs-module-scss-module__Xu-Rca__list",
  "listCta": "Breadcrumbs-module-scss-module__Xu-Rca__listCta",
  "pageHeader": "Breadcrumbs-module-scss-module__Xu-Rca__pageHeader",
  "pageHeaderBreadcrumb": "Breadcrumbs-module-scss-module__Xu-Rca__pageHeaderBreadcrumb",
  "pageHeaderHeading": "Breadcrumbs-module-scss-module__Xu-Rca__pageHeaderHeading",
  "pageHeaderHomeLink": "Breadcrumbs-module-scss-module__Xu-Rca__pageHeaderHomeLink",
  "pageHeaderNoPadding": "Breadcrumbs-module-scss-module__Xu-Rca__pageHeaderNoPadding",
  "pageHeaderSeparator": "Breadcrumbs-module-scss-module__Xu-Rca__pageHeaderSeparator",
  "pageHeaderTrail": "Breadcrumbs-module-scss-module__Xu-Rca__pageHeaderTrail",
  "separatorSlash": "Breadcrumbs-module-scss-module__Xu-Rca__separatorSlash",
  "shimmer-slide": "Breadcrumbs-module-scss-module__Xu-Rca__shimmer-slide",
  "skeleton": "Breadcrumbs-module-scss-module__Xu-Rca__skeleton",
  "skeletonChevron": "Breadcrumbs-module-scss-module__Xu-Rca__skeletonChevron",
  "skeletonItem": "Breadcrumbs-module-scss-module__Xu-Rca__skeletonItem",
  "wrapper": "Breadcrumbs-module-scss-module__Xu-Rca__wrapper",
  "wrapperCta": "Breadcrumbs-module-scss-module__Xu-Rca__wrapperCta",
});
